import { useState } from 'react';
import { useAtom } from 'jotai';
import { FolderOpen, Code } from 'lucide-react';
import { toast } from 'sonner';
import { currentProjectAtom } from '@/stores/editorStore';
import DatabaseDropdown from '@/components/Preview/DatabaseDropdown';
import FileExplorer from './FileExplorer';
import CodeEditor from './CodeEditor';

export default function TopMenu() {
  const [currentProject] = useAtom(currentProjectAtom);
  const [showFiles, setShowFiles] = useState(false);
  const [showEditor, setShowEditor] = useState(false);
  const [selectedFile, setSelectedFile] = useState<string | null>(null);

  const handleCodeEditorClick = () => {
    if (!selectedFile) {
      toast.error('Please select a file from Files first');
      setShowFiles(true);
      return;
    }
    setShowEditor(true);
  };

  return (
    <>
      <div className="border-b bg-background px-4 py-2 flex items-center">
        <div className="flex items-center gap-2">
          {currentProject && <DatabaseDropdown projectId={currentProject.id} />}

          <button
            onClick={() => setShowFiles(!showFiles)}
            className="flex items-center gap-2 px-3 py-1.5 text-sm hover:bg-muted rounded-md transition-colors"
          >
            <FolderOpen className="w-4 h-4" />
            Files
          </button>

          <button
            onClick={handleCodeEditorClick}
            className="flex items-center gap-2 px-3 py-1.5 text-sm hover:bg-muted rounded-md transition-colors"
          >
            <Code className="w-4 h-4" />
            Code Editor
          </button>
        </div>
      </div>

      {/* File Explorer Modal */}
      {showFiles && (
        <FileExplorer
          onClose={() => setShowFiles(false)}
          onSelectFile={(file) => {
            setSelectedFile(file);
            setShowFiles(false);
            setShowEditor(true);
          }}
        />
      )}

      {/* Code Editor Modal */}
      {showEditor && selectedFile && (
        <CodeEditor
          filePath={selectedFile}
          onClose={() => {
            setShowEditor(false);
            setSelectedFile(null);
          }}
        />
      )}
    </>
  );
}
